import LegalLayout, { H2, H3, UL } from "@/components/layout/LegalLayout";

export default function Security() {
  return (
    <LegalLayout titleKey="security" title="Security" testId="legal-security-page">
      <H2>Our Security Commitment</H2>
      <p>
        AtlasForge Financial is committed to maintaining industry-standard
        safeguards to protect customer information and financial data across
        Safe to Spend 365, Ember360, and our API platform.
      </p>

      <H2>Data Protection</H2>
      <H3>Encryption</H3>
      <UL items={["TLS encryption for data in transit", "Industry-standard encryption for sensitive data at rest", "Secure credential handling practices"]} />

      <H3>Bank Connectivity</H3>
      <p>Bank account connections are facilitated through trusted providers such as Plaid.</p>
      <p>AtlasForge Financial does not store your online banking usernames or passwords.</p>

      <H3>Payment Security</H3>
      <p>Payment processing is powered by trusted providers including Stripe and related payment infrastructure partners.</p>
      <p>Sensitive payment credentials are handled by certified payment processors.</p>

      <H2>Access Controls</H2>
      <p>We implement:</p>
      <UL items={["Role-based access controls", "Least-privilege access policies", "Multi-factor authentication for internal systems", "Continuous monitoring and logging"]} />

      <H2>Infrastructure Security</H2>
      <p>We maintain:</p>
      <UL items={["Secure cloud infrastructure", "Automated monitoring", "Vulnerability management", "Backup and disaster recovery procedures"]} />

      <H2>Fraud Prevention</H2>
      <p>We utilize automated and manual systems designed to identify:</p>
      <UL items={["Unauthorized access", "Suspicious transactions", "Fraudulent activity", "Account abuse"]} />

      <H2>Responsible Disclosure</H2>
      <p>If you discover a security vulnerability, please report it to:</p>
      <p>customersupport@atlasforgefinancial.com</p>
      <p>Please include:</p>
      <UL items={["Description of the issue", "Steps to reproduce", "Supporting screenshots or evidence"]} />
      <p>We appreciate responsible disclosure and will investigate all legitimate reports promptly.</p>

      <H2>Security Questions</H2>
      <p>For security-related inquiries:</p>
      <p>customersupport@atlasforgefinancial.com</p>
      <p>843-291-2556</p>
    </LegalLayout>
  );
}
